<!--
┌────────────────────────────────────────────────┐
│                                                │
│  ┌───────────┐  ┌───────────────────────────┐  │
│  │           │  │      top-side             │  │
│  │   image   │  └───────────────────────────┘  │
│  │           │  ┌───────────────────────────┐  │
│  │           │  │       bottom-side         │  │
│  └───────────┘  └───────────────────────────┘  │
│                                                │
└────────────────────────────────────────────────┘
-->

<img class="image" [src]="item?.image + PresentationConstants.imagePrefix.desktop.productOthers" [alt]="item?.name + ' image'" />
<div class="body">
  <div class="top-side">
    <div class="code_and_name">
      <span class="code">REF. {{ item?.code }}</span>
      <h2 class="name">{{ item?.name }}</h2>
    </div>

    <ep-remove-cart-line-from-cart
      [product]="item"
      [promotionCode]="promotionCode"
    ></ep-remove-cart-line-from-cart>
  </div>
  <div class="bottom-side">
    <div class="units_and_prices">
      <span class="units">
        {{
          "product_tile.box_of_n_units"
            | translate: { quantity: item?.units ?? 0 }
        }}
      </span>
      <div *ngIf="!(isPriceHidden$ | async)" class="prices">
        <span class="price">{{ item?.price | localizedCurrency }}</span>
        <span class="unit-price">
          {{ item?.unitPrice | localizedCurrency }}
          {{ "product_tile.unit" | translate | lowercase }}
        </span>
      </div>
    </div>
    <ep-cart-line-quantity-setter
      [product]="item ?? undefined"
      [promotionCode]="promotionCode"
    ></ep-cart-line-quantity-setter>
  </div>
</div>
